import { approvedProductsService } from "services/approvedProducts.service";

let vendorName = { displayName: "Company", name: "VendorName", orderable: true }
let bid = { displayName: "BID", name: "BID", orderable: false }
let emvCoRefNum = { displayName: "EMVCo\nReference\nNumber", name: "EMVCoRefNum", orderable: false }
let visaCompIdInternal = { displayName: "Visa Secure\nApproval ID", name: "VisaCompId", orderable: false }
let visaCompIdPublic = { displayName: "Visa Secure\nApproval ID", name: "VisaCompId", orderable: false }
let expirationDate = { displayName: "Expires", name: "ExpirationDate", orderable: true }
let validity ={ displayName: "Validity", name: "Validity", orderable: false }
let component = { displayName: "Component", name: "Component", orderable: true }
let protocolVersion = { displayName: "Protocol\nVersion\u00B9", name: "ProtocolVersion", orderable: false }
let productName = { displayName: "Product", name: "ProductName", orderable: true }
let vendorContactInternal = { displayName: "Partner\nEmail", name: "VendorContact", orderable: false }
let vendorContactPublic = { displayName: "Partner Email", name: "VendorContact", orderable: false }
let sca = { displayName: "SCA\u00B2", name: "SupportSCATestCases", orderable: false }
let daf = { displayName: "DAF\u00B3", name: "SupportDAFTestCases", orderable: false }
let bme = { displayName: "BME\u2074", name: "SupportBMETestCases", orderable: false }

let publicIndicator = { displayName: "Public\nOpt-in", name: "PublicIndicator", orderable: false }

export const colHeadersAll = [
  vendorName,
  bid,
  component,
  protocolVersion,
  productName,
  sca,
  daf,
  bme,
  visaCompIdInternal,
  expirationDate,
  emvCoRefNum,
  validity,
  vendorContactInternal,
  publicIndicator
];


export const colHeadersPublic = [
  vendorName,
  component,
  protocolVersion,
  productName,
  sca,
  daf,
  bme,
  visaCompIdPublic,
  expirationDate,
  validity,
  vendorContactPublic
];

const COMPONENTS = "components"
const SUPPORT_TEST_CASES = "supportTestCases"
const PROTOCOL_VERSIONS = "protocolVersions"
const LISTING_TYPE = "listingType"
const defaultTags = () => {
  let tags = {}
  tags[COMPONENTS] = {
    value: COMPONENTS,
    title: "EMV 3DS Component Type",
    items: [
      { name: "3DS Server", checked: false, value: "3DS SERVER" },
      { name: "ACS", checked: false, value: "ACS" }]
  }

  tags[SUPPORT_TEST_CASES] = {
    value: SUPPORT_TEST_CASES,
    title: "Certified",
    items: [
      { name: "Supports SCA", checked: false },
      { name: "Supports DAF", checked: false },
      { name: "Supports BME", checked: false },
    ]
  }

  tags[PROTOCOL_VERSIONS] = {
    value: PROTOCOL_VERSIONS,
    title: "Protocol Version",
    items: []
  }

  return tags
}

export const createTags = (versions, isAdmin) => {

  let tags = defaultTags()

  let protocolItems = []
  for (let version of versions) {
    protocolItems.push({
      name: "EMV 3DS " + version,
      checked: false,
      value: version
    })
  }
  tags[PROTOCOL_VERSIONS].items = protocolItems

  if (isAdmin) {
    tags[LISTING_TYPE] = {
      value: LISTING_TYPE,
      title: "Listing Type",
      items: [
        { name: "Products (OK to Publish)", checked: false, value: "Y" },
        { name: "Products (Do Not Publish)", checked: false, value: "" }
      ]
    }
  }
  return tags
}


export function createFilterFromTags(newTags, isAdmin) {
  let newFilter = approvedProductsService.prepareFilter()

  // Components
  for (let item of newTags[COMPONENTS].items) {
    if (item.checked) {
      newFilter.components.push(item.value)
    }
  }

  // Protocol Versions
  for (let item of newTags[PROTOCOL_VERSIONS].items) {
    if (item.checked) {
      newFilter.protocolVersions.push(item.value)
    }
  }

  // Test Cases
  if (newTags[SUPPORT_TEST_CASES].items[0].checked) {
    newFilter.supportSCATestCases = "Y"
  }

  if (newTags[SUPPORT_TEST_CASES].items[1].checked) {
    newFilter.supportDAFTestCases = "Y"
  }

  if (newTags[SUPPORT_TEST_CASES].items[2].checked) {
    newFilter.supportBMETestCases = "Y"
  }


  // Listing Type, default filter values are true
  if (isAdmin) {
    let publishedProducts = newTags[LISTING_TYPE].items[0].checked
    let unpublishedProducts = newTags[LISTING_TYPE].items[1].checked

    if (publishedProducts) {
      newFilter.publishedProducts = "Y"
    }
    if (unpublishedProducts) {
      newFilter.unpublishedProducts = "Y"
    }
  }

  return newFilter
}